import React from 'react'
import { Link } from "gatsby"
import Photo01 from '../assets/PalomaArteDeImpactar.png'
import Card4 from '../components/Card4'

const BarEMPRESA = () => {
    return (
        <div className='lg:py-16'>
            <Card4/> 
            <div className='text-center'>
                <Link to={`/`} activeStyle={{ color: 'black' }} activeClassName='active' href="#responsive-header" className="py-2 menuBarStyle block mt-4 lg:inline-block lg:mt-0  hover:text-red-900 mx-10">
                    <p className='btn-ronsof-one-blue'>Apresentação</p>
                </Link>
            </div>
        </div>
    )
}
export default BarEMPRESA